import { Form } from "react-bootstrap";

const PAGE_SIZE_OPTIONS = [5, 10, 25, 50];

interface FeatureFlagListToolbarProps {
  pageSize: number;
  searchValue: string;
  /** Element id for the search input; must be unique when several toolbars are on the page. */
  searchInputId?: string;
  searchAriaLabel?: string;
  onPageSizeChange: (pageSize: number) => void;
  onSearchChange: (value: string) => void;
}

/** Renders page-size and search controls above a feature flag table. */
function FeatureFlagListToolbar({
  pageSize,
  searchValue,
  searchInputId = "featureFlagSearch",
  searchAriaLabel = "Search feature flags by name or description",
  onPageSizeChange,
  onSearchChange,
}: FeatureFlagListToolbarProps) {
  return (
    <div className="featureFlagListToolbar">
      <div className="pageSizeControl">
        <span>Show </span>
        <Form.Control
          as="select"
          size="sm"
          className="pageSizeSelect"
          value={pageSize}
          onChange={(e) => onPageSizeChange(Number(e.target.value))}
          aria-label="Rows per page"
        >
          {PAGE_SIZE_OPTIONS.map((size) => (
            <option key={size} value={size}>
              {size}
            </option>
          ))}
        </Form.Control>
        <span> entries</span>
      </div>
      <div className="searchControl">
        <label htmlFor={searchInputId} className="mb-0 mr-2">
          Search:
        </label>
        <Form.Control
          id={searchInputId}
          type="search"
          size="sm"
          value={searchValue}
          onChange={(e) => onSearchChange(e.target.value)}
          aria-label={searchAriaLabel}
        />
      </div>
    </div>
  );
}

export default FeatureFlagListToolbar;
